<template>
  <div class="modal-backdrop" @click="$emit('close')">
    <div class="modal" @click.stop="">
      <h1>Для заключения Договора:</h1>
      <div class="points">
        <ol>
          <li><h3>Скачайте заявление по ссылке:</h3></li>
          <a href="https://drive.google.com/file/d/1_Y-l9TNgNQl9BlSFfpwxHnElhYyFKDHL/view?usp=sharing" target="_blank"> Ссылка для скачивания </a>
          <li><h3>Распечатайте и собственноручно заполните заявление</h3></li>
          <li><h3>Отправьте заполненное заявление на WhatsApp</h3> <a href="tel:89035498889"><h3>8-903-549-88-89</h3></a> <h3>или на почту</h3> <a href="mailto:7452209@mail.ru"><h3>7452209@mail.ru</h3></a></li>
          <li><h3>Ожидайте оферту Договора в ответном сообщении</h3></li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['close']
}
</script>

<style scoped>

a {
  text-decoration: underline;
}

h1 {
  text-align: center;
  font-family: "Poppins", sans-serif !important;
  margin: 0;
}

ol {
  margin: 0;
}

 h3 {
  text-align: left;
  font-family: "Poppins", sans-serif !important;
}

.points {
  flex-direction: column;
  display: flex;
  justify-content: center;
}

@media (max-height: 600px) {
  h3 {
    font-size: 16px;
  }

  .points {
    flex-direction: row;
  }
}

</style>